import { TOGGLE_SWITCH_STATUS } from "constants/constants";
import { useEffect, useState } from "react";
import "./ToggleSwitchButton.scss";
import PropTypes from "prop-types";

const ToggleSwitchButton = ({ value, index, disabled }) => {
  const [status, setStatus] = useState("");

  useEffect(() => {
    value?.length > 0 && setStatus(value);
  }, [value]);

  const lightGreen = "#D7F6E3";
  const lightYellow = "#FBF1D6";
  const lightRed = "#FCD6CE";

  const getBackgroupColor = () => {
    switch (status) {
      case TOGGLE_SWITCH_STATUS.ON:
        return lightGreen;
      case TOGGLE_SWITCH_STATUS.NA:
        return lightYellow;
      case TOGGLE_SWITCH_STATUS.OFF:
        return lightRed;
    }
  };

  return (
    <div
      className="switch-toggle switch-3 switch-candy"
      style={{ background: getBackgroupColor() }}
    >
      <input
        id={`on${index}`}
        className={status === TOGGLE_SWITCH_STATUS.ON && "checked"}
        name={`state${index}`}
        type="radio"
        checked={status === TOGGLE_SWITCH_STATUS.ON}
        onChange={() => setStatus(TOGGLE_SWITCH_STATUS.ON)}
        disabled={disabled}
        style={{ cursor: disabled ? "" : "pointer" }}
      />
      <label
        htmlFor={`on${index}`}
        {...(status === TOGGLE_SWITCH_STATUS.ON && {
          style: { background: "#44B269" },
        })}
      />

      <input
        id={`na${index}`}
        className={status === TOGGLE_SWITCH_STATUS.NA && "checked"}
        name={`state${index}`}
        type="radio"
        checked={status === TOGGLE_SWITCH_STATUS.NA}
        onChange={() => setStatus(TOGGLE_SWITCH_STATUS.NA)}
        disabled={disabled}
        style={{ cursor: disabled ? "" : "pointer" }}
      />
      <label
        htmlFor={`na${index}`}
        {...(status === TOGGLE_SWITCH_STATUS.NA && {
          style: { background: "#E79D0E" },
        })}
      />

      <input
        id={`off${index}`}
        className={status === TOGGLE_SWITCH_STATUS.OFF && "checked"}
        name={`state${index}`}
        type="radio"
        checked={status === TOGGLE_SWITCH_STATUS.OFF}
        onChange={() => setStatus(TOGGLE_SWITCH_STATUS.OFF)}
        disabled={disabled}
        style={{ cursor: disabled ? "" : "pointer" }}
      />
      <label
        htmlFor={`off${index}`}
        {...(status === TOGGLE_SWITCH_STATUS.OFF && {
          style: { background: "#E42929" },
        })}
      />
    </div>
  );
};

ToggleSwitchButton.propTypes = {
  value: PropTypes.string,
  index: PropTypes.any.isRequired,
  true: PropTypes.bool,
  disabled: PropTypes.bool,
};

ToggleSwitchButton.defaultProps = {
  true: true,
  value: "",
};

export default ToggleSwitchButton;
